// import { useState } from "react";
// import { TableRow, TableCell, Button, TextField, Grid, Typography } from "@mui/material";
// import { customeStyle } from "utils/style";
// import { useCart } from "utils/CartContext";

// const CartItemNote = ({ itemId, onSave }) => {

//   const { couponctx, orderNotesctx, updateCouponctx, saveNotectx } = useCart();
//   const [showTextField, setShowTextField] = useState(false);
//   const [note, setNote] = useState("");
//   const [savedNote, setSavedNote] = useState(""); // State to hold saved note

//   const handleSave = () => {
//     saveNotectx(itemId, note)
//     onSave(itemId, note);      // Call the save function with itemId and note
//     setSavedNote(note);       // Update saved note
//     setShowTextField(false);  // Close the text field
//   };

//   const handleCancel = () => {
//     setNote("");              // Clear text field input
//     setShowTextField(false);  // Close the text field without saving
//   };

//   return (
//     <>
//       <Grid container justifyContent="space-between" sx={{ mt: 1, mb: 1 }} lg={11.5} margin="auto">
//         {/* Display saved note only if it exists */}
//         {savedNote && (
//           <Typography sx={{ fontSize: customeStyle.typography.subhading, mb: 2 }}>
//             {savedNote}
//           </Typography>
//         )}
//       </Grid>

//       {showTextField && (
//         <TableRow>
//           <TableCell colSpan={3}>
//             <TextField
//               fullWidth
//               sx={{
//                 '& .MuiInputBase-root': { fontSize: '1rem', padding: '10px' },
//                 '& .MuiFormLabel-root': { fontSize: '1rem' },
//                 '& .MuiOutlinedInput-root': { minHeight: '30px' }
//               }}
//               label="Enter your note"
//               value={note}
//               onChange={(e) => setNote(e.target.value)}
//               multiline
//               rows={1}
//               size="small"
//             />
//           </TableCell>
//         </TableRow>
//       )}

//       <TableRow>
//         <TableCell colSpan={6}>
//           <Grid  container justifyContent={showTextField?"flex-end":"flex-start"} sx={{ mt: 1, mb: 1 }}  margin="auto">
//             <Button
//               variant="outlined"
//               sx={{ p: 0.3,mr:2, fontSize: customeStyle.typography.subhading1, textTransform: "none" }}
//               size="small"
//               onClick={() => showTextField ? handleCancel() : setShowTextField(true)}
//             >
//               {showTextField ? "Cancel" : "Add Order Note"}
//             </Button>

//             {showTextField && (
//               <Button
//                 sx={{ p: 0.5, fontSize: customeStyle.typography.subhading1, textTransform: "none" }}
//                 variant="contained"
//                 size="small"
//                 onClick={handleSave}
//                 disabled={!note.trim()} // Disable save if note is empty
//               >
//                 Save Note
//               </Button>
//             )}
//           </Grid>
//         </TableCell>
//       </TableRow>
//     </>
//   );
// };

// export default CartItemNote;

// import { useState, useEffect } from "react";
// import { TableRow, TableCell, Button, TextField, Grid, Typography } from "@mui/material";
// import { customeStyle } from "utils/style";
// import { useCart } from "utils/CartContext";

// const CartItemNote = ({ itemId, onSave }) => {
//   const { orderNotesctx, saveNotectx } = useCart();
//   const [showTextField, setShowTextField] = useState(false);
//   const [note, setNote] = useState("");
//   const [savedNote, setSavedNote] = useState("");

//   // ✅ Sync note with context when itemId changes
//   useEffect(() => {
//     const existingNote = orderNotesctx[itemId] || "";
//     setNote(existingNote);        // Set note input
//     setSavedNote(existingNote);   // Set displayed saved note
//   }, [itemId, orderNotesctx]);

//   const handleSave = () => {
//     saveNotectx(itemId, note);      // Save to context
//     onSave(itemId, note);          // Notify parent component
//     setSavedNote(note);           // Update saved note state
//     setShowTextField(false);      // Hide input field
//   };

//   const handleCancel = () => {
//     setNote(savedNote);           // Revert to saved note
//     setShowTextField(false);      // Close input field
//   };

//   return (
//     <>
//       <Grid container justifyContent="space-between" sx={{ mt: 1, mb: 1 }} lg={11.5} margin="auto">
//       {savedNote && (
//   <Typography sx={{ fontSize: customeStyle.typography.subhading, mb: 2 }}>
//     {savedNote.order_instruction}  {/* ✅ Access the string inside the object */}
//   </Typography>
// )}

//       </Grid>

//       {showTextField && (
//         <TableRow>
//           <TableCell colSpan={3}>
//             <TextField
//               variant="standard"
//               fullWidth
//               label="Enter your note"
//               value={note.order_instruction}
//               onChange={(e) => setNote(e.target.value)}
//               // multiline
//               // rows={1}
//               size="small"
//               sx={{
//                 '& .MuiInputBase-root': {
//                   fontSize: '1rem',
//                   padding: '6px 12px', // Adjust padding for better alignment
//                   lineHeight: '1.5', // Improve vertical alignment
//                 },
//                 '& .MuiFormLabel-root': {
//                   fontSize: '1rem',
//                   lineHeight: '1.2', // Adjust line height for label positioning
//                 },
//                 '& .MuiOutlinedInput-root': {
//                   alignItems: 'center', // Ensure vertical alignment without changing height
//                 },
//               }}
//             />

//           </TableCell>
//         </TableRow>
//       )}

//       <TableRow>
//         <TableCell colSpan={6}>
//           <Grid container justifyContent={showTextField ? "flex-end" : "flex-start"} sx={{ mt: 1, mb: 1 }} margin="auto">
//             <Button
//               variant="outlined"
//               size="small"
//               onClick={() => (showTextField ? handleCancel() : setShowTextField(true))}
//               sx={{ p: 0.3, mr: 2, fontSize: customeStyle.typography.subhading1, textTransform: "none" }}
//             >
//               {showTextField ? "Cancel" : "Add Order Note"}
//             </Button>
//             {showTextField && (
//               <Button
//                 variant="contained"
//                 size="small"
//                 onClick={handleSave}
//                 disabled={!showTextField}
//                 sx={{ p: 0.5, fontSize: customeStyle.typography.subhading1, textTransform: "none" }}
//               >
//                 Save Note
//               </Button>
//             )}
//           </Grid>
//         </TableCell>
//       </TableRow>
//     </>
//   );
// };

// export default CartItemNote;
import { useState, useEffect } from "react";
import {
  TableRow,
  TableCell,
  Button,
  Grid,
  Typography,
  MenuItem,
  Box,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { useCart } from "utils/CartContext";
import axiosInstance from "configs/axiosConfig";
import { APIRouteConstants } from "constants/routeConstants";
import { customeStyle } from "utils/style";

const FIELD_HEIGHT = 32;

const CartItemNote = ({ itemId, onSave, websiteInfo }) => {
  const { orderNotesctx, saveNotectx } = useCart();

  const [showField, setShowField] = useState(false);
  const [note, setNote] = useState("");
  const [savedNote, setSavedNote] = useState("");
  const [selectedBreak, setSelectedBreak] = useState("");
  const [breakOptions, setBreakOptions] = useState([]);
  const [loadingBreak, setLoadingBreak] = useState(true);

  const showBreak = websiteInfo?.is_school_college === true;
  const isRequired = websiteInfo?.order_note_required === true;
  const showBreakDropdown =
    !loadingBreak && breakOptions.length > 0 && showBreak && isRequired;

  useEffect(() => {
    const getBreakTypes = async () => {
      try {
        const res = await axiosInstance.get(
          APIRouteConstants.DASHBOARD.BREAK_LANGUAGES,
          { isPublic: true },
        );

        const data = res?.data || [];

        const unique = [];
        data.forEach((item) => {
          if (!unique.find((b) => b.id === item.break_type.id)) {
            unique.push({
              id: item.break_type.id,
              name: item.break_type.name,
            });
          }
        });
        unique.sort((a, b) => a.id - b.id);
        setBreakOptions(unique);
      } catch (err) {
        console.error("Break type error", err);
      } finally {
        setLoadingBreak(false);
      }
    };

    getBreakTypes();
  }, []);

  // ✅ SYNC NOTE
  useEffect(() => {
    const existing = orderNotesctx[itemId]?.order_instruction || "";

    setSavedNote(existing);

    if (existing.includes(": ")) {
      const [breakLabel, ...rest] = existing.split(": ");
      setSelectedBreak(breakLabel);
      setNote(rest.join(": "));
    } else {
      setNote(existing);
    }
  }, [itemId, orderNotesctx]);

  // ✅ SAVE
  const handleSave = () => {
    if (!note.trim()) return;

    saveNotectx(itemId, note, selectedBreak);
    onSave(itemId, note, selectedBreak);

    // setSavedNote(finalNote);
    setShowField(false);
  };

  // ✅ CANCEL
  const handleCancel = () => {
    setShowField(false);
    setNote(savedNote);
    setSelectedBreak("");
  };

  const btnSx = {
    height: `${FIELD_HEIGHT}px`,
    minHeight: `${FIELD_HEIGHT}px`,
    fontSize: "0.7rem",
    padding: "0 12px",
    textTransform: "none",
    display: "flex",
    alignItems: "center",
  };

  return (
    <>
      {/* ✅ Saved Note */}
      {savedNote && (
        <Grid
          container
          sx={{
            mt: 1,
            mb: 1,
            maxHeight: "80px",
            overflowY: "auto",
          }}
        >
          <Typography
            sx={{
              fontSize: customeStyle.typography.subhading,
              wordBreak: "break-word",
              overflowWrap: "anywhere",
              whiteSpace: "normal",
            }}
          >
            {orderNotesctx[itemId]?.break_type &&
              `${orderNotesctx[itemId]?.break_type} : `}
            {orderNotesctx[itemId]?.order_instruction}
          </Typography>
        </Grid>
      )}

      {/* ✅ Fields */}
      {showField && (
        <TableRow>
          <TableCell colSpan={6}>
            <Grid container spacing={1.5} alignItems="center" wrap="wrap">
              {/* 🔥 BREAK TYPE (FIXED) */}
              {!loadingBreak &&
                breakOptions.length > 0 &&
                showBreak &&
                isRequired && (
                  <Grid item xs={12} sm={3} md={2.5}>
                    <FormControl fullWidth size="small">
                      <InputLabel
                        shrink={false}
                        sx={{
                          fontSize: "0.7rem",
                          top: "50%",
                          transform: "translateY(-50%)",
                          left: "12px",
                          display: selectedBreak ? "none" : "block",
                        }}
                      >
                        Break Type
                      </InputLabel>

                      <Select
                        value={selectedBreak}
                        onChange={(e) => setSelectedBreak(e.target.value)}
                        displayEmpty
                        sx={{
                          height: `${FIELD_HEIGHT}px`,
                          fontSize: "0.7rem",
                          "& .MuiSelect-select": {
                            display: "flex",
                            alignItems: "center",
                            padding: "0 10px",
                          },
                        }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              "& .MuiMenuItem-root": {
                                fontSize: "0.7rem",

                                // ✅ mobile vs desktop control
                                minHeight: {
                                  xs: "32px", // mobile compact
                                  sm: "32px", // desktop normal
                                },
                              },
                            },
                          },
                        }}
                      >
                        {breakOptions.map((item) => (
                          <MenuItem
                            key={item.id}
                            value={item.name}
                            sx={{ fontSize: "0.7rem" }}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}

              {/* 🔥 ORDER NOTE */}
              {(showBreak ? selectedBreak : true) && (
                <Grid item xs={12} sm md>
                  <Box
                    component="textarea"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    placeholder="Order Note"
                    rows={1}
                    onInput={(e) => {
                      const el = e.target;
                      el.style.height = `${FIELD_HEIGHT}px`; // reset
                      el.style.height = Math.min(el.scrollHeight, 120) + "px";
                    }}
                    sx={{
                      width: "100%",
                      height: `${FIELD_HEIGHT}px`,
                      minHeight: `${FIELD_HEIGHT}px`,
                      maxHeight: "120px",
                      padding: "6px 10px",
                      fontSize: "0.7rem",
                      borderRadius: "4px",
                      border: "1px solid",
                      borderColor: "grey.400",
                      resize: "none",
                      outline: "none",
                      boxSizing: "border-box",
                      display: "flex",
                      alignItems: "center",
                    }}
                  />
                </Grid>
              )}

              {/* 🔥 BUTTONS */}
              {(showBreak ? selectedBreak : true) && (
                <Grid
                  item
                  xs={12}
                  sm="auto"
                  md="auto"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: {
                      xs: "stretch", // mobile full width
                      sm: "flex-end", // same row right
                    },
                  }}
                >
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={handleCancel}
                      sx={btnSx}
                    >
                      Cancel
                    </Button>

                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleSave}
                      disabled={!note.trim()}
                      sx={btnSx}
                    >
                      Save
                    </Button>
                  </Box>
                </Grid>
              )}
            </Grid>
          </TableCell>
        </TableRow>
      )}

      {/* ✅ ADD BUTTON */}
      {!showField && (
        <TableRow>
          <TableCell colSpan={6}>
            <Button
              variant="outlined"
              size="small"
              onClick={() => setShowField(true)}
              sx={btnSx}
            >
              + Add Order Note
            </Button>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default CartItemNote;
